import styled from 'styled-components'
import Footer from '../Footer/Footer'
import media from '../../../../services/generateMediaQueries'
import confetti from '../../../../assets/img/simplified-login/confetti.png'

export const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #868686;

  ${media.lessThan('small')`
    font-size: 14px;
  `}
`
// LEFT PANE COMPONENTS
export const LeftPane = styled.div`
  height: 100vh;
  flex-grow: 1;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  // ST-5832
  // justify-content: space-between;
  justify-content: flex-end;
  position: relative;
  background:
    linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%),
    url('${props => props.bannerImage}') center / cover no-repeat;

  // &::before {
  //   content: ' ';
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   bottom: 0;
  //   z-index: -1;
  //   width: calc(100vw - 350px);
  //   background:
  //     linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%),
  //     url('${props => props.bannerImage}') center / cover no-repeat;
  // }

  ${media.lessThan('small')`
    display: none;
  `}
`
export const StyledFooter = styled(Footer)`
  display: flex;
  align-self: flex-end;
`
export const LogoContainer = styled.div`
  background-image: linear-gradient(
    340deg,
    rgba(255, 255, 255, 0) 40%,
    rgba(255, 255, 255, 1) 100%
  );
  padding: 50px;
  height: 100%;
  width: 100%;
`
export const Logo = styled.img`
  height: 80px;
  ${media.lessThan('small')`
    height: 48px;
  `}
`

// RIGHT PANE COMPONENTS
export const RightPane = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 600px;
  min-width: 350px;
  overflow: auto;
  background: var(--color-bg-light);
  // position: fixed;
  // top: 0;
  // right: 0;

  ${media.lessThan('small')`
    width: 100vw;
    min-width: unset;
    max-width: unset;
  `}
`
export const AppVersion = styled.span`
  position: absolute;
  top: 1em;
  right: 1em;
  font-size: 14px;
  ${media.lessThan('small')`
    color: #fff;
  `}
`
export const RightFooter = styled.div`
  width: 100%;
  min-height: 140px;
  ${media.lessThan('small')`
    min-height: unset;
  `}
`
export const MobileBanner = styled.div`
  min-height: 230px;
  padding: 0.5rem;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background:
    // linear-gradient(180deg, rgba(0, 0, 0, 0) 30%, var(--color-bg-light) 90%),
    url('${props => props.bannerImage}') center / cover no-repeat;
  ${media.greaterThan('small')`
    display: none;
  `}
`
export const MobileFooterWrapper = styled.div`
  height: max-content;
  ${media.greaterThan('small')`
    display: none;
  `}
`
